exports.default = {
  'title': '選擇參考圖',
  'selected_title': '選擇圖片',
  'selected_count': '已選擇 {current}/{max} 張',
  'source_tabs': '圖片來源',
  'open_picker': '選擇參考圖片',
  'image': '圖片',
  'recent': '最近',
  'assets': '資產',
  'all_assets': '全部資產',
  'default_space': '預設空間',
  'folder_filter': '按資料夾篩選',
  'upload_action': '點擊/拖曳上傳',
  'upload_hint': 'PNG、JPG、JPEG、WebP，單張不超過 20 MB',
  'uploading': '上傳中 {current}/{total}',
  'limit_reached': '已達上限',
  'image_alt': '參考圖片',
  'remove': '移除',
  'remove_image': '移除圖片 {name}',
  'select_image': '選擇圖片 {name}',
  'unselect_image': '取消選擇圖片 {name}',
  'unnamed': '未命名圖片',
  'empty_recent': '暫無最近上傳的圖片',
  'empty_assets': '暫無圖片資產',
  'load_failed': '圖片載入失敗',
  'loading_more': '正在載入更多...',
  'retry': '重試',
  'retry_folders': '重新載入資料夾',
  'retry_preview': '重試預覽',
  'retry_image_preview': '重新載入圖片 {name}',
  'loading_preview': '正在載入',
  'retry_load_more': '載入失敗，點擊重試',
  'unsupported_type': '{count} 張圖片格式不受支援，已略過',
  'file_too_large': '{count} 張圖片超過 20 MB，已略過',
  'remaining_limit': '目前還可選擇 {count} 張圖片',
  'max_count': '最多選擇 {count} 張圖片',
  'upload_failed': '{count} 張圖片上傳失敗，請重試',
  'play_audio': '試聽',
  'pause_audio': '暫停',
  'retry_audio': '重試試聽',
  'stop_audio': '停止試聽',
  'audio_audition': '音訊試聽',
  'audio_failed': '音訊暫時無法播放，請重試試聽或使用播放控制項。',
  'media_selected_title': '選擇素材',
  'media_selected_count': '已選擇 {current}/{max} 項',
  'media_source_tabs': '素材來源',
  'media_remove_image': '移除素材 {name}',
  'media_select_image': '選擇素材 {name}',
  'media_unselect_image': '取消選擇素材 {name}',
  'media_unnamed': '未命名素材',
  'media_empty_recent': '暫無最近上傳的素材',
  'media_empty_assets': '暫無素材資產',
  'media_load_failed': '素材載入失敗',
  'media_retry_image_preview': '重新載入素材 {name}',
  'media_unsupported_type': '{count} 個素材格式不受支援，已略過',
  'media_file_too_large': '{count} 個素材為空或超過 50MiB，已略過',
  'media_remaining_limit': '目前還可選擇 {count} 項素材',
  'media_max_count': '最多選擇 {count} 項素材',
  'media_upload_failed': '{count} 個素材上傳失敗，請重試',
  'cancel': '取消',
  'confirm': '確認使用'
}
